module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAABZklEQVRYR+2ZwS5DURCG/7+3WisRaUkJOwtWKtJEIo0NXgIbb+EBvIUNT4EFuSXiRlqbtgs7QoNG6EqrtyNHc4uuT3rdZGZ35iRz/nxnZhYzxLcJXbeUcoaTGx1wByKLAEa6dwO3BshiDLLvfzSP8vlsHaDQiLy8rmbbvuyRXBcxvvCNpIjIcdzh7vLSXImuW0wzmTwksSaCWPgSfxSQ6IjgRJrNLV545U0BDwzJuOMgMzGGzPgoEomhUDS3Wp+oPb+h9vSKtu/DkCVkmwWvcgqRVaNqejKNmamUuQxFZPCoiODuoY77x5euizxj4ar8HhRObmE2NJL9ZAxZ7+Y2cDeMUAlOK7n5UEn2P37uVXouFWrja5SoDYq/YyhRJWp6vvZRC3mgxWQB4p8QSlSJanuylANaTJZA9sIoUSWq7clSDmgxWQKp7ck2SCU6MKIRGTtGZZAbmdF4ZJYNkVnfdEv2/y/EvgBgqXqwiypuEQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/unselect.png
// module id = 938
// module chunks = 0